export { default } from './DeadlineTimer';



// WEBPACK FOOTER //
// ./src/components/Common/DeadlineTimer/index.js